import {gql, useQuery} from '@apollo/client';
import {useParams} from 'react-router-dom';
import {
  GetInterestedParties,
  GetInterestedPartiesVariables,
} from '../schema-types/GetInterestedParties';
import validateUUID from '../utils/validateUUID';

const GET_ACCOUNT_INTERESTED_PARTIES = gql`
  query GetInterestedParties($accountId: UUID!) {
    accountDetails(accountId: $accountId, curoSync: true, syncContacts: false) {
      id
      isTrust
      interestedParties {
        id
        contact {
          id
          name
          simplifiedName
          fullName
        }
      }
    }
  }
`;

export const useAccountInterestedParties = () => {
  const {accountId} = useParams();
  const {
    loading: interestedPartiesLoading,
    data: interestedPartiesData,
    error: interestedPartiesError,
  } = useQuery<GetInterestedParties, GetInterestedPartiesVariables>(
    GET_ACCOUNT_INTERESTED_PARTIES,
    {
      variables: {
        accountId: validateUUID(accountId)!,
      },
      nextFetchPolicy: 'network-only',
      fetchPolicy: 'network-only',
      skip: !accountId,
    }
  );

  return {
    interestedPartiesLoading,
    interestedParties: interestedPartiesData?.accountDetails.interestedParties ?? [],
    interestedPartiesError,
    isTrust: interestedPartiesData?.accountDetails.isTrust,
  };
};
